// -----------------------------------------------------------------------------
//
// This file is the copyrighted property of Tableau Software and is protected
// by registered patents and other applicable U.S. and international laws and
// regulations.
//
// Unlicensed use of the contents of this file is prohibited. Please refer to
// the NOTICES.txt file for further details.
//
// -----------------------------------------------------------------------------
import { call, put } from 'redux-saga/effects';

import { Set } from '~commonInfra/utils/Set';
import { requestSpaceContents } from '~src/spacesPlatform/actions/RequestSpaceContentsActions';

import { requestFailed } from '../../../bootstrap/redux/actions/RequestFailedAction';
import { Messages } from '../../../codegen/Localize';
import { IExtractTaskInfo } from '../../../extractTask/models/IExtractTaskInfo';
import { ResumeExtractTasksAction } from '../../../extractTask/services/ResumeExtractTasksAction';
import { ResumeExtractRefreshAction } from '../../actions/extractRefresh/ResumeExtractRefreshAction';

export function* handleResumeExtractRefreshAction(action: ResumeExtractRefreshAction) {
  try {
    yield call(executeResumeExtractRefresh, action.tasks);
    yield put(requestSpaceContents());
  } catch (e) {
    yield put(requestFailed(e, Messages.unexpectedError()));
  }
}

export function executeResumeExtractRefresh(items: IExtractTaskInfo[]) {
  return ResumeExtractTasksAction.execute(Set.fromIdItemArray(items));
}
